export default "__VITE_ASSET__4yvledo7__"